export const SUPPORT_LIST_ID = '217189683'
export const FEEDBACK_LIST_ID = '217164828'
